import React from "react";
import { Route, Routes } from "react-router-dom";
import { Container } from "./Departments.styled";
import { Breadcrumb } from "./components";
import { useDepartmentsBreadcrumbs } from "./hooks";
import { Main, DepartmentDetail } from "./pages";
import { UsersForDepartmentsProvider } from "./context";

const Departments = () => {
  const { items: breadcrumbItems, helpers: breadcrumbHelpers } = useDepartmentsBreadcrumbs();

  return (
    <UsersForDepartmentsProvider>
      <Container>
        {/* <Breadcrumb items={breadcrumbItems} /> */}
        <Routes>
          <Route path=":departmentId/*" element={<DepartmentDetail breadcrumbHelpers={breadcrumbHelpers} />} />
          <Route path="/*" element={<Main breadcrumbHelpers={breadcrumbHelpers} />} />
        </Routes>
      </Container>
    </UsersForDepartmentsProvider>
  );
};

export default Departments;

